// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let ReactRelay = require("react-relay");
let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let DevicePixelRatio = require("../v5/common/DevicePixelRatio.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

function makeRefetchVariables(id) {
  return {
    id: id
  };
}

let Types = {
  makeRefetchVariables: makeRefetchVariables
};

function unwrap_response_conversationById(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "ConversationV5",
    "NotAuthorizedError"
  ]);
}

let variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"conversationById_ConversationV5":{"f":""},"conversationById":{"u":"response_conversationById"}}};

let wrapResponseConverterMap = {
  response_conversationById: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"conversationById_ConversationV5":{"f":""},"conversationById":{"u":"response_conversationById"}}};

let responseConverterMap = {
  response_conversationById: unwrap_response_conversationById
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let providedVariablesDefinition = {
  __relay_internal__pv__DevicePixelRatio: {
    providedVariable: DevicePixelRatio.get,
    get: DevicePixelRatio.get
  }
};

function makeNode(providedVariablesDefinition) {
  return ((function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = [
  (v2/*: any*/)
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v6 = [
  (v4/*: any*/),
  (v5/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Agent",
  "kind": "LinkedField",
  "name": "agent",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v8 = [
  (v2/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v7/*: any*/)
    ],
    "type": "VisibleForSalePropertyAgent",
    "abstractKey": null
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "beds",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baths",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "halfBaths",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "LotSize",
  "kind": "LinkedField",
  "name": "lotSizeV2",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unit",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "livingArea",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v15 = {
  "kind": "InlineFragment",
  "selections": [
    (v9/*: any*/),
    (v10/*: any*/),
    (v11/*: any*/),
    (v12/*: any*/),
    (v13/*: any*/),
    (v14/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parkingSpaces",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parkingDetails",
      "storageKey": null
    }
  ],
  "type": "CondoProperty",
  "abstractKey": null
},
v16 = {
  "kind": "InlineFragment",
  "selections": [
    (v9/*: any*/),
    (v10/*: any*/),
    (v11/*: any*/),
    (v12/*: any*/),
    (v13/*: any*/),
    (v14/*: any*/)
  ],
  "type": "SingleFamilyProperty",
  "abstractKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "onTanAt",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "onMlsAt",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "willAcceptOffersPriorToMls",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "willShowPriorToMls",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "activeOnMlsOn",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "website",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "ChapterV5",
  "kind": "LinkedField",
  "name": "chapter",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timezone",
      "storageKey": null
    },
    (v5/*: any*/)
  ],
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": (v3/*: any*/),
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v27 = {
  "kind": "Literal",
  "name": "embed",
  "value": true
},
v28 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 1
    }
  ],
  "concreteType": "PropertyImageConnection",
  "kind": "LinkedField",
  "name": "images",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PropertyImageEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ImageAttachment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "crop",
                  "value": false
                },
                (v27/*: any*/),
                {
                  "kind": "Literal",
                  "name": "height",
                  "value": 324
                },
                {
                  "kind": "Literal",
                  "name": "width",
                  "value": 324
                }
              ],
              "kind": "ScalarField",
              "name": "url",
              "storageKey": "url(crop:false,embed:true,height:324,width:324)"
            },
            (v5/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "images(first:1)"
},
v29 = [
  {
    "kind": "Literal",
    "name": "includeOnlyActive",
    "value": true
  }
],
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v31 = [
  (v4/*: any*/),
  (v14/*: any*/),
  (v5/*: any*/)
],
v32 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "format",
        "value": "FULL"
      }
    ],
    "kind": "ScalarField",
    "name": "formatted",
    "storageKey": "formatted(format:\"FULL\")"
  }
],
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "Price",
  "kind": "LinkedField",
  "name": "maxPrice",
  "plural": false,
  "selections": (v32/*: any*/),
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "Price",
  "kind": "LinkedField",
  "name": "minPrice",
  "plural": false,
  "selections": (v32/*: any*/),
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "PriceRange",
  "kind": "LinkedField",
  "name": "priceRange",
  "plural": false,
  "selections": [
    (v33/*: any*/),
    (v34/*: any*/)
  ],
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locationDisplay",
  "storageKey": null
},
v37 = [
  (v36/*: any*/)
],
v38 = {
  "kind": "InlineFragment",
  "selections": (v37/*: any*/),
  "type": "PropertyLocationWithHiddenAddress",
  "abstractKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "propertyLocation",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v38/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v36/*: any*/),
        (v39/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "visibilityRule",
          "storageKey": null
        }
      ],
      "type": "PropertyLocationWithVisibleAddress",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "mlsPlan",
  "plural": false,
  "selections": [
    {
      "kind": "TypeDiscriminator",
      "abstractKey": "__isMlsPlan"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "willShow",
          "storageKey": null
        }
      ],
      "type": "NoMlsPlan",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "activeOnMlsSince",
  "storageKey": null
},
v43 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Price",
      "kind": "LinkedField",
      "name": "price",
      "plural": false,
      "selections": (v32/*: any*/),
      "storageKey": null
    }
  ],
  "type": "ExactPrice",
  "abstractKey": null
},
v44 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "price",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "kind": "TypeDiscriminator",
          "abstractKey": "__isPropertyPrice"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v34/*: any*/),
            (v33/*: any*/)
          ],
          "type": "PriceRange",
          "abstractKey": null
        },
        (v43/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "PropertyV5",
  "abstractKey": "__isPropertyV5"
},
v45 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "agentV2Id",
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "agentV2",
      "plural": false,
      "selections": (v8/*: any*/),
      "storageKey": null
    },
    (v44/*: any*/)
  ],
  "type": "ForSalePropertyV5",
  "abstractKey": null
},
v46 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "agentId",
      "args": null,
      "concreteType": "Agent",
      "kind": "LinkedField",
      "name": "agent",
      "plural": false,
      "selections": (v6/*: any*/),
      "storageKey": null
    },
    (v44/*: any*/)
  ],
  "type": "RentalPropertyV5",
  "abstractKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "availableFrom",
  "storageKey": null
},
v48 = [
  (v14/*: any*/)
],
v49 = {
  "alias": null,
  "args": null,
  "concreteType": "LeaseLengthV5",
  "kind": "LinkedField",
  "name": "leaseLength",
  "plural": false,
  "selections": (v48/*: any*/),
  "storageKey": null
},
v50 = {
  "kind": "InlineFragment",
  "selections": [
    (v5/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headline",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "remarks",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "concreteType": "ClientContactsConnection",
  "kind": "LinkedField",
  "name": "contacts",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ClientContactsEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ClientContactV5",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v14/*: any*/),
            (v5/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v54 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "format",
        "value": "SHORT"
      }
    ],
    "kind": "ScalarField",
    "name": "formatted",
    "storageKey": "formatted(format:\"SHORT\")"
  }
],
v55 = {
  "alias": null,
  "args": null,
  "concreteType": "PriceRange",
  "kind": "LinkedField",
  "name": "priceRange",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Price",
      "kind": "LinkedField",
      "name": "maxPrice",
      "plural": false,
      "selections": (v54/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Price",
      "kind": "LinkedField",
      "name": "minPrice",
      "plural": false,
      "selections": (v54/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v57 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Area",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v56/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "label",
        "storageKey": null
      },
      (v5/*: any*/)
    ],
    "storageKey": null
  }
],
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minBeds",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "price",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v43/*: any*/)
  ],
  "storageKey": null
},
v60 = {
  "kind": "Variable",
  "name": "ratio",
  "variableName": "__relay_internal__pv__DevicePixelRatio"
},
v61 = {
  "kind": "Literal",
  "name": "width",
  "value": 60
},
v62 = {
  "alias": null,
  "args": [
    (v60/*: any*/),
    (v61/*: any*/)
  ],
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "membershipStatus",
  "storageKey": null
},
v64 = {
  "alias": "agentProfilePhoto",
  "args": null,
  "concreteType": "ProfilePhoto",
  "kind": "LinkedField",
  "name": "profilePhoto",
  "plural": false,
  "selections": [
    (v62/*: any*/)
  ],
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v66 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 500
  }
],
v67 = [
  (v4/*: any*/)
],
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "broadcastAt",
  "storageKey": null
},
v69 = {
  "kind": "Literal",
  "name": "crop",
  "value": true
},
v70 = {
  "kind": "Literal",
  "name": "width",
  "value": 1200
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ConversationPageExistingConversationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "conversationById",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ConversationPageSelectedConversationDisplayer_conversation"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ConversationPageExistingConversation_conversation"
              }
            ],
            "type": "ConversationV5",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v3/*: any*/),
            "type": "NotAuthorizedError",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__DevicePixelRatio"
      }
    ],
    "kind": "Operation",
    "name": "ConversationPageExistingConversationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "conversationById",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "anonymous",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "conversationContext",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isContextForConversation"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "context",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isConversationContextV5"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "agentV2",
                                "plural": false,
                                "selections": (v8/*: any*/),
                                "storageKey": null
                              },
                              (v4/*: any*/),
                              (v5/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "propertyType",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v15/*: any*/),
                                  (v16/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v12/*: any*/),
                                      (v14/*: any*/)
                                    ],
                                    "type": "LotProperty",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "numberOfUnits",
                                        "storageKey": null
                                      },
                                      (v14/*: any*/)
                                    ],
                                    "type": "MultiUnitProperty",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "commission",
                                "storageKey": null
                              },
                              (v17/*: any*/),
                              (v18/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PropertyShowingConnection",
                                "kind": "LinkedField",
                                "name": "showings",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PropertyShowingEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ShowingV5",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "startDate",
                                            "storageKey": null
                                          },
                                          (v5/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "mlsPlan",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v19/*: any*/),
                                      (v20/*: any*/),
                                      (v21/*: any*/)
                                    ],
                                    "type": "ListOnMlsAsActive",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v22/*: any*/),
                                      (v20/*: any*/),
                                      (v21/*: any*/)
                                    ],
                                    "type": "ListOnMlsAsComingSoon",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v23/*: any*/),
                              (v24/*: any*/),
                              (v25/*: any*/),
                              (v26/*: any*/),
                              {
                                "alias": "forSaleMatchingType",
                                "args": null,
                                "kind": "ScalarField",
                                "name": "matchingType",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Seller",
                                "kind": "LinkedField",
                                "name": "client",
                                "plural": false,
                                "selections": (v6/*: any*/),
                                "storageKey": null
                              },
                              (v28/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "matchingType",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": (v29/*: any*/),
                                "concreteType": "ForSalePropertyCurrentUserMatchesConnection",
                                "kind": "LinkedField",
                                "name": "currentUsersMatches",
                                "plural": false,
                                "selections": [
                                  (v30/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ForSalePropertyCurrentUserMatchesEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "MatchForBuyerNeedV5",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v4/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "BuyerNeedV5",
                                            "kind": "LinkedField",
                                            "name": "source",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Buyer",
                                                "kind": "LinkedField",
                                                "name": "client",
                                                "plural": false,
                                                "selections": (v31/*: any*/),
                                                "storageKey": null
                                              },
                                              (v35/*: any*/),
                                              (v5/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v5/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "currentUsersMatches(includeOnlyActive:true)"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v40/*: any*/),
                                  (v41/*: any*/),
                                  (v42/*: any*/),
                                  (v45/*: any*/),
                                  (v46/*: any*/)
                                ],
                                "type": "PropertyV5",
                                "abstractKey": "__isPropertyV5"
                              }
                            ],
                            "type": "ForSalePropertyV5",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/),
                              (v4/*: any*/),
                              (v25/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "propertyType",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v15/*: any*/),
                                  (v16/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v17/*: any*/),
                              (v18/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "mlsPlan",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v19/*: any*/)
                                    ],
                                    "type": "ListOnMlsAsActive",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v22/*: any*/)
                                    ],
                                    "type": "ListOnMlsAsComingSoon",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v23/*: any*/),
                              (v24/*: any*/),
                              (v47/*: any*/),
                              (v49/*: any*/),
                              (v26/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Landlord",
                                "kind": "LinkedField",
                                "name": "client",
                                "plural": false,
                                "selections": (v6/*: any*/),
                                "storageKey": null
                              },
                              (v28/*: any*/),
                              {
                                "alias": null,
                                "args": (v29/*: any*/),
                                "concreteType": "RentalPropertyCurrentUserMatchesConnection",
                                "kind": "LinkedField",
                                "name": "currentUsersMatches",
                                "plural": false,
                                "selections": [
                                  (v30/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RentalPropertyCurrentUserMatchesEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "MatchForRentalNeedV5",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v4/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "RentalNeedV5",
                                            "kind": "LinkedField",
                                            "name": "source",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Renter",
                                                "kind": "LinkedField",
                                                "name": "client",
                                                "plural": false,
                                                "selections": (v31/*: any*/),
                                                "storageKey": null
                                              },
                                              (v35/*: any*/),
                                              (v5/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v5/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "currentUsersMatches(includeOnlyActive:true)"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v41/*: any*/),
                                  (v42/*: any*/),
                                  (v40/*: any*/),
                                  (v45/*: any*/),
                                  (v46/*: any*/)
                                ],
                                "type": "PropertyV5",
                                "abstractKey": "__isPropertyV5"
                              }
                            ],
                            "type": "RentalPropertyV5",
                            "abstractKey": null
                          },
                          (v50/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v4/*: any*/),
                              (v51/*: any*/),
                              (v52/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Buyer",
                                "kind": "LinkedField",
                                "name": "client",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v5/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v2/*: any*/),
                                      (v53/*: any*/)
                                    ],
                                    "type": "ClientV5",
                                    "abstractKey": "__isClientV5"
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Agent",
                                "kind": "LinkedField",
                                "name": "agent",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v5/*: any*/),
                                  (v14/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v55/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "BuyerNeedAreaConnection",
                                "kind": "LinkedField",
                                "name": "areas",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "BuyerNeedAreaEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": (v57/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "BuyerNeedPropertyType",
                                "kind": "LinkedField",
                                "name": "propertyTypes",
                                "plural": true,
                                "selections": (v48/*: any*/),
                                "storageKey": null
                              },
                              (v58/*: any*/),
                              {
                                "alias": "buyerNeedMatchingType",
                                "args": null,
                                "kind": "ScalarField",
                                "name": "matchingType",
                                "storageKey": null
                              },
                              (v25/*: any*/),
                              {
                                "alias": null,
                                "args": (v29/*: any*/),
                                "concreteType": "BuyerNeedCurrentUserMatchesConnection",
                                "kind": "LinkedField",
                                "name": "currentUsersMatches",
                                "plural": false,
                                "selections": [
                                  (v30/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "BuyerNeedCurrentUserMatchesEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "MatchForForSalePropertyV5",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v4/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ForSalePropertyV5",
                                            "kind": "LinkedField",
                                            "name": "source",
                                            "plural": false,
                                            "selections": [
                                              (v59/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "propertyLocation",
                                                "plural": false,
                                                "selections": [
                                                  (v2/*: any*/),
                                                  (v38/*: any*/),
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      (v36/*: any*/),
                                                      (v39/*: any*/)
                                                    ],
                                                    "type": "PropertyLocationWithVisibleAddress",
                                                    "abstractKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Seller",
                                                "kind": "LinkedField",
                                                "name": "client",
                                                "plural": false,
                                                "selections": [
                                                  (v4/*: any*/),
                                                  (v14/*: any*/),
                                                  (v53/*: any*/),
                                                  (v5/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              (v5/*: any*/),
                                              {
                                                "alias": "forSalePropertyMatchingType",
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "matchingType",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          (v5/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "currentUsersMatches(includeOnlyActive:true)"
                              }
                            ],
                            "type": "BuyerNeedV5",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v4/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Agent",
                                "kind": "LinkedField",
                                "name": "agent",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v14/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "brokerage",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProfilePhoto",
                                    "kind": "LinkedField",
                                    "name": "profilePhoto",
                                    "plural": false,
                                    "selections": [
                                      (v62/*: any*/),
                                      {
                                        "alias": "urlWithRing",
                                        "args": [
                                          (v60/*: any*/),
                                          {
                                            "kind": "Literal",
                                            "name": "ring",
                                            "value": true
                                          },
                                          (v61/*: any*/)
                                        ],
                                        "kind": "ScalarField",
                                        "name": "url",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v63/*: any*/),
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CategoryV5",
                                "kind": "LinkedField",
                                "name": "category",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "shortName",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "subject",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "body",
                                "storageKey": null
                              }
                            ],
                            "type": "MessageBroadcast",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v4/*: any*/),
                              (v51/*: any*/),
                              (v52/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Renter",
                                "kind": "LinkedField",
                                "name": "client",
                                "plural": false,
                                "selections": (v6/*: any*/),
                                "storageKey": null
                              },
                              (v7/*: any*/),
                              (v55/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RentalNeedAreaConnection",
                                "kind": "LinkedField",
                                "name": "areas",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RentalNeedAreaEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": (v57/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RentalNeedPropertyType",
                                "kind": "LinkedField",
                                "name": "propertyTypes",
                                "plural": true,
                                "selections": (v48/*: any*/),
                                "storageKey": null
                              },
                              (v58/*: any*/),
                              (v47/*: any*/),
                              (v49/*: any*/),
                              (v25/*: any*/),
                              {
                                "alias": null,
                                "args": (v29/*: any*/),
                                "concreteType": "RentalNeedCurrentUserMatchesConnection",
                                "kind": "LinkedField",
                                "name": "currentUsersMatches",
                                "plural": false,
                                "selections": [
                                  (v30/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RentalNeedCurrentUserMatchesEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "MatchForRentalPropertyV5",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "RentalPropertyV5",
                                            "kind": "LinkedField",
                                            "name": "source",
                                            "plural": false,
                                            "selections": [
                                              (v59/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "propertyLocation",
                                                "plural": false,
                                                "selections": [
                                                  (v2/*: any*/),
                                                  (v38/*: any*/),
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": (v37/*: any*/),
                                                    "type": "PropertyLocationWithVisibleAddress",
                                                    "abstractKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Landlord",
                                                "kind": "LinkedField",
                                                "name": "client",
                                                "plural": false,
                                                "selections": (v31/*: any*/),
                                                "storageKey": null
                                              },
                                              (v5/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v5/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "currentUsersMatches(includeOnlyActive:true)"
                              }
                            ],
                            "type": "RentalNeedV5",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v4/*: any*/),
                              (v56/*: any*/),
                              (v26/*: any*/),
                              (v7/*: any*/)
                            ],
                            "type": "DevelopmentProject",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v4/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "DevelopmentProject",
                                "kind": "LinkedField",
                                "name": "development",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v56/*: any*/),
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v56/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "unitType",
                                "storageKey": null
                              },
                              (v26/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "beds",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v9/*: any*/)
                                    ],
                                    "type": "DevelopmentProjectUnitExactBeds",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v58/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "maxBeds",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "DevelopmentProjectUnitBedsRange",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "baths",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v10/*: any*/)
                                    ],
                                    "type": "DevelopmentProjectUnitExactBaths",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "minBaths",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "maxBaths",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "DevelopmentProjectUnitBathsRange",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "squareFeet",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "squareFeet",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "DevelopmentProjectUnitExactSquareFeet",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "minSquareFeet",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "maxSquareFeet",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "DevelopmentProjectUnitSquareFeetRange",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v7/*: any*/)
                            ],
                            "type": "DevelopmentProjectSampleUnit",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "AvailableConversationContext",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "entityType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Agent",
                        "kind": "LinkedField",
                        "name": "agent",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v63/*: any*/),
                          (v14/*: any*/),
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "RemovedConversationContext",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "conversationParticipants",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 20
                  }
                ],
                "concreteType": "ConversationParticipantConnection",
                "kind": "LinkedField",
                "name": "participants",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ConversationParticipantEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v4/*: any*/),
                              (v14/*: any*/),
                              (v64/*: any*/),
                              (v63/*: any*/)
                            ],
                            "type": "Agent",
                            "abstractKey": null
                          },
                          (v50/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "participants(first:20)"
              },
              (v65/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "readOnly",
                "storageKey": null
              },
              (v65/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ConversationParticipantConnection",
                "kind": "LinkedField",
                "name": "participants",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ConversationParticipantEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v14/*: any*/),
                              (v63/*: any*/)
                            ],
                            "type": "Agent",
                            "abstractKey": null
                          },
                          (v50/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v5/*: any*/),
              {
                "alias": null,
                "args": (v66/*: any*/),
                "concreteType": "ConversationTimelineConnection",
                "kind": "LinkedField",
                "name": "conversationTimeline",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ConversationTimelineItemEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "content",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v67/*: any*/),
                                    "type": "BuyerNeedV5",
                                    "abstractKey": null
                                  },
                                  (v50/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v68/*: any*/),
                              (v4/*: any*/)
                            ],
                            "type": "BuyerNeedBroadcast",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "content",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v67/*: any*/),
                                    "type": "ForSalePropertyV5",
                                    "abstractKey": null
                                  },
                                  (v50/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v68/*: any*/),
                              (v4/*: any*/)
                            ],
                            "type": "ForSalePropertyBroadcast",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "content",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v67/*: any*/),
                                    "type": "RentalNeedV5",
                                    "abstractKey": null
                                  },
                                  (v50/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v68/*: any*/),
                              (v4/*: any*/)
                            ],
                            "type": "RentalNeedBroadcast",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "content",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v67/*: any*/),
                                    "type": "RentalPropertyV5",
                                    "abstractKey": null
                                  },
                                  (v50/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v68/*: any*/),
                              (v4/*: any*/)
                            ],
                            "type": "RentalPropertyBroadcast",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v4/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "sentAt",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "from",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v4/*: any*/),
                                      (v14/*: any*/),
                                      (v63/*: any*/),
                                      (v64/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "firstName",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "phone",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "Agent",
                                    "abstractKey": null
                                  },
                                  (v50/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "text",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "state",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "IncomingMessageStatus",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ConversationMessageImageConnection",
                                "kind": "LinkedField",
                                "name": "images",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ConversationMessageImageEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ImageAttachment",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": "oneOfSeveralUrl",
                                            "args": [
                                              (v69/*: any*/),
                                              {
                                                "kind": "Literal",
                                                "name": "height",
                                                "value": 200
                                              },
                                              (v60/*: any*/),
                                              {
                                                "kind": "Literal",
                                                "name": "width",
                                                "value": 200
                                              }
                                            ],
                                            "kind": "ScalarField",
                                            "name": "url",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": [
                                              (v60/*: any*/),
                                              {
                                                "kind": "Literal",
                                                "name": "width",
                                                "value": 400
                                              }
                                            ],
                                            "kind": "ScalarField",
                                            "name": "url",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": "carouselFullscreen",
                                            "args": [
                                              (v60/*: any*/),
                                              (v70/*: any*/)
                                            ],
                                            "kind": "ScalarField",
                                            "name": "url",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": "carouselLarge",
                                            "args": [
                                              {
                                                "kind": "Literal",
                                                "name": "height",
                                                "value": 800
                                              },
                                              (v60/*: any*/),
                                              (v70/*: any*/)
                                            ],
                                            "kind": "ScalarField",
                                            "name": "url",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": "carouselSmall",
                                            "args": [
                                              (v27/*: any*/),
                                              {
                                                "kind": "Literal",
                                                "name": "height",
                                                "value": 500
                                              },
                                              (v60/*: any*/),
                                              {
                                                "kind": "Literal",
                                                "name": "width",
                                                "value": 750
                                              }
                                            ],
                                            "kind": "ScalarField",
                                            "name": "url",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": "carouselThumb",
                                            "args": [
                                              (v69/*: any*/),
                                              {
                                                "kind": "Literal",
                                                "name": "height",
                                                "value": 90
                                              },
                                              (v60/*: any*/),
                                              {
                                                "kind": "Literal",
                                                "name": "width",
                                                "value": 90
                                              }
                                            ],
                                            "kind": "ScalarField",
                                            "name": "url",
                                            "storageKey": null
                                          },
                                          (v5/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ConversationMessageFileConnection",
                                "kind": "LinkedField",
                                "name": "files",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ConversationMessageFileEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "FileAttachment",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "fileName",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "url",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "key",
                                            "storageKey": null
                                          },
                                          (v5/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ConversationMessageV5",
                            "abstractKey": null
                          },
                          (v50/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "conversationTimeline(first:500)"
              },
              {
                "alias": null,
                "args": (v66/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "ConversationPageConversationMessages_conversation_conversationTimeline",
                "kind": "LinkedHandle",
                "name": "conversationTimeline"
              },
              {
                "kind": "ClientExtension",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__id",
                    "storageKey": null
                  }
                ]
              }
            ],
            "type": "ConversationV5",
            "abstractKey": null
          },
          (v50/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7d86c05ad2d3507fbf47110b5281edd8",
    "id": null,
    "metadata": {},
    "name": "ConversationPageExistingConversationQuery",
    "operationKind": "query",
    "text": "query ConversationPageExistingConversationQuery(\n  $id: ID!\n  $__relay_internal__pv__DevicePixelRatio: Float!\n) {\n  conversationById(id: $id) {\n    __typename\n    ... on ConversationV5 {\n      ...ConversationPageSelectedConversationDisplayer_conversation\n      ...ConversationPageExistingConversation_conversation\n    }\n    ... on NotAuthorizedError {\n      __typename\n    }\n    ... on Node {\n      __isNode: __typename\n      __typename\n      nodeId\n    }\n  }\n}\n\nfragment AgentInfo_agent on Agent {\n  id\n  displayName\n  brokerage\n  profilePhoto {\n    url(width: 60, ratio: $__relay_internal__pv__DevicePixelRatio)\n    urlWithRing: url(width: 60, ratio: $__relay_internal__pv__DevicePixelRatio, ring: true)\n  }\n  membershipStatus\n}\n\nfragment AgentProfilePhoto_agent on Agent {\n  displayName\n  agentProfilePhoto: profilePhoto {\n    url(width: 60, ratio: $__relay_internal__pv__DevicePixelRatio)\n  }\n}\n\nfragment AgentPropertyMlsStatus_mlsPlan on MlsPlan {\n  __isMlsPlan: __typename\n  __typename\n  ... on AlreadyOnMls {\n    __typename\n  }\n  ... on ListOnMlsAsActive {\n    onMlsAt\n  }\n  ... on ListOnMlsAsComingSoon {\n    activeOnMlsOn\n  }\n  ... on NoMlsPlan {\n    willShow\n  }\n}\n\nfragment AgentPropertyMlsStatus_property on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  mlsPlan {\n    __typename\n    ...AgentPropertyMlsStatus_mlsPlan\n  }\n  activeOnMlsSince\n}\n\nfragment BuyerNeedStatus_buyerNeedV5 on BuyerNeedV5 {\n  status {\n    __typename\n    ... on ActiveBuyerNeed {\n      __typename\n    }\n    ... on ExpiredBuyerNeed {\n      __typename\n    }\n    ... on InContractBuyerNeed {\n      __typename\n    }\n    ... on PurchasedBuyerNeed {\n      __typename\n    }\n    ... on WithdrawnBuyerNeed {\n      __typename\n    }\n  }\n}\n\nfragment CondoPropertyAttributes_condoProperty on CondoProperty {\n  beds\n  baths\n  halfBaths\n  lotSizeV2 {\n    value\n    unit\n  }\n  livingArea\n  displayName\n}\n\nfragment ConversationConversationsSectionReplyInput_DeactivatedConversationWarning_conversation on ConversationV5 {\n  participants {\n    edges {\n      node {\n        __typename\n        ... on Agent {\n          displayName\n          membershipStatus\n        }\n        ... on Node {\n          __isNode: __typename\n          __typename\n          nodeId\n        }\n      }\n    }\n  }\n}\n\nfragment ConversationConversationsSectionReplyInput_conversation on ConversationV5 {\n  id\n  readOnly\n  visibility\n  ...ConversationConversationsSectionReplyInput_DeactivatedConversationWarning_conversation\n}\n\nfragment ConversationMessageFiles_conversationMessage on ConversationMessageV5 {\n  files {\n    edges {\n      node {\n        fileName\n        url\n        key\n        nodeId\n      }\n    }\n  }\n}\n\nfragment ConversationMessageImages_OneOfSeveralImages_image on ImageAttachment {\n  oneOfSeveralUrl: url(width: 200, height: 200, crop: true, ratio: $__relay_internal__pv__DevicePixelRatio)\n}\n\nfragment ConversationMessageImages_SingleImage_image on ImageAttachment {\n  url(width: 400, ratio: $__relay_internal__pv__DevicePixelRatio)\n}\n\nfragment ConversationMessageImages_conversationMessage on ConversationMessageV5 {\n  images {\n    edges {\n      node {\n        ...ConversationMessageImages_OneOfSeveralImages_image\n        ...ConversationMessageImages_SingleImage_image\n        carouselFullscreen: url(width: 1200, ratio: $__relay_internal__pv__DevicePixelRatio)\n        carouselLarge: url(width: 1200, height: 800, ratio: $__relay_internal__pv__DevicePixelRatio)\n        carouselSmall: url(width: 750, height: 500, embed: true, ratio: $__relay_internal__pv__DevicePixelRatio)\n        carouselThumb: url(width: 90, height: 90, crop: true, ratio: $__relay_internal__pv__DevicePixelRatio)\n        nodeId\n      }\n    }\n  }\n}\n\nfragment ConversationPageConversationMessagesMessageChat_chatParticipantMenuAgent on Agent {\n  firstName\n  phone\n  id\n}\n\nfragment ConversationPageConversationMessagesMessage_conversation on ConversationV5 {\n  visibility\n}\n\nfragment ConversationPageConversationMessagesMessage_message on ConversationMessageV5 {\n  id\n  from {\n    __typename\n    ... on Agent {\n      id\n      displayName\n      membershipStatus\n      ...AgentProfilePhoto_agent\n      ...ConversationPageConversationMessagesMessageChat_chatParticipantMenuAgent\n    }\n    ... on Node {\n      __isNode: __typename\n      __typename\n      nodeId\n    }\n  }\n  text\n  sentAt\n  status {\n    __typename\n    ... on IncomingMessageStatus {\n      state\n    }\n  }\n  ...ConversationMessageImages_conversationMessage\n  ...ConversationMessageFiles_conversationMessage\n}\n\nfragment ConversationPageConversationMessages_conversation on ConversationV5 {\n  ...ConversationPageConversationMessagesMessage_conversation\n  id\n  nodeId\n  conversationTimeline(first: 500) {\n    edges {\n      node {\n        __typename\n        ... on BuyerNeedBroadcast {\n          content {\n            __typename\n            ... on BuyerNeedV5 {\n              id\n            }\n            ... on Node {\n              __isNode: __typename\n              __typename\n              nodeId\n            }\n          }\n          broadcastAt\n          id\n        }\n        ... on ForSalePropertyBroadcast {\n          content {\n            __typename\n            ... on ForSalePropertyV5 {\n              id\n            }\n            ... on Node {\n              __isNode: __typename\n              __typename\n              nodeId\n            }\n          }\n          broadcastAt\n          id\n        }\n        ... on RentalNeedBroadcast {\n          content {\n            __typename\n            ... on RentalNeedV5 {\n              id\n            }\n            ... on Node {\n              __isNode: __typename\n              __typename\n              nodeId\n            }\n          }\n          broadcastAt\n          id\n        }\n        ... on RentalPropertyBroadcast {\n          content {\n            __typename\n            ... on RentalPropertyV5 {\n              id\n            }\n            ... on Node {\n              __isNode: __typename\n              __typename\n              nodeId\n            }\n          }\n          broadcastAt\n          id\n        }\n        ... on ConversationMessageV5 {\n          id\n          sentAt\n          ...ConversationPageConversationMessagesMessage_message\n          status {\n            __typename\n            ... on IncomingMessageStatus {\n              state\n            }\n          }\n        }\n        ... on Node {\n          __isNode: __typename\n          __typename\n          nodeId\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ConversationPageConversation_conversation on ConversationV5 {\n  visibility\n  ...ConversationConversationsSectionReplyInput_conversation\n  ...ConversationPageConversationMessages_conversation\n  conversationContext {\n    __typename\n    ...ConversationPageNotAnonymousWarning_conversationContext\n  }\n}\n\nfragment ConversationPageExistingConversation_conversation on ConversationV5 {\n  conversationContext {\n    __typename\n    ... on AvailableConversationContext {\n      context {\n        __typename\n        ...ConversationsPageRelayCommon_conversationContext\n        ... on Node {\n          __isNode: __typename\n          __typename\n          nodeId\n        }\n      }\n    }\n  }\n}\n\nfragment ConversationPageNotAnonymousWarning_conversationContext on ContextForConversation {\n  __isContextForConversation: __typename\n  __typename\n  ... on AvailableConversationContext {\n    context {\n      __typename\n      ... on BuyerNeedV5 {\n        agent {\n          displayName\n          nodeId\n        }\n        currentUsersMatches(includeOnlyActive: true) {\n          edges {\n            node {\n              source {\n                client {\n                  displayName\n                  nodeId\n                }\n                forSalePropertyMatchingType: matchingType\n                nodeId\n              }\n              nodeId\n            }\n          }\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        __typename\n        nodeId\n      }\n    }\n  }\n}\n\nfragment ConversationPageSelectedConversationAnonymousControl_conversation on ConversationV5 {\n  anonymous\n  conversationContext {\n    __typename\n    ... on AvailableConversationContext {\n      context {\n        __typename\n        ... on ForSalePropertyV5 {\n          agentV2 {\n            __typename\n            ... on VisibleForSalePropertyAgent {\n              agent {\n                id\n                nodeId\n              }\n            }\n          }\n        }\n        ... on RentalPropertyV5 {\n          agent {\n            id\n            nodeId\n          }\n        }\n        ... on Node {\n          __isNode: __typename\n          __typename\n          nodeId\n        }\n      }\n    }\n  }\n}\n\nfragment ConversationPageSelectedConversationContextRemovedContextCard_agent on Agent {\n  id\n  membershipStatus\n  displayName\n}\n\nfragment ConversationPageSelectedConversationContext_broadcast on MessageBroadcast {\n  id\n  agent {\n    ...AgentInfo_agent\n    nodeId\n  }\n  category {\n    shortName\n  }\n  subject\n  body\n}\n\nfragment ConversationPageSelectedConversationContext_buyerNeed on BuyerNeedV5 {\n  id\n  headline\n  remarks\n  client {\n    id\n    ...ConversationsPageRelayCommonGetClientNames_client\n    nodeId\n  }\n  agent {\n    id\n    nodeId\n  }\n  priceRange {\n    maxPrice {\n      formatted(format: SHORT)\n    }\n    minPrice {\n      formatted(format: SHORT)\n    }\n  }\n  areas {\n    edges {\n      node {\n        name\n        label\n        nodeId\n      }\n    }\n  }\n  propertyTypes {\n    displayName\n  }\n  minBeds\n  buyerNeedMatchingType: matchingType\n  ...BuyerNeedStatus_buyerNeedV5\n}\n\nfragment ConversationPageSelectedConversationContext_conversation on ContextForConversation {\n  __isContextForConversation: __typename\n  __typename\n  ... on RemovedConversationContext {\n    entityType\n    agent {\n      ...ConversationPageSelectedConversationContextRemovedContextCard_agent\n      nodeId\n    }\n  }\n  ... on AvailableConversationContext {\n    context {\n      __typename\n      ... on BuyerNeedV5 {\n        ...ConversationPageSelectedConversationContext_buyerNeed\n      }\n      ... on ForSalePropertyV5 {\n        ...ConversationPageSelectedConversationContext_forSaleProperty\n      }\n      ... on MessageBroadcast {\n        ...ConversationPageSelectedConversationContext_broadcast\n      }\n      ... on RentalNeedV5 {\n        ...ConversationPageSelectedConversationContext_rentalNeed\n      }\n      ... on RentalPropertyV5 {\n        ...ConversationPageSelectedConversationContext_rentalProperty\n      }\n      ... on DevelopmentProject {\n        ...ConversationPageSelectedConversationContext_developmentProject\n      }\n      ... on DevelopmentProjectSampleUnit {\n        ...ConversationPageSelectedConversationContext_developmentSampleUnit\n      }\n      ... on Node {\n        __isNode: __typename\n        __typename\n        nodeId\n      }\n    }\n  }\n}\n\nfragment ConversationPageSelectedConversationContext_developmentProject on DevelopmentProject {\n  id\n  name\n  description\n}\n\nfragment ConversationPageSelectedConversationContext_developmentSampleUnit on DevelopmentProjectSampleUnit {\n  id\n  development {\n    id\n    name\n    nodeId\n  }\n  name\n  unitType\n  description\n  ...DevelopmentUnitSearchResultAttributes_newDevelopmentSampleUnit\n}\n\nfragment ConversationPageSelectedConversationContext_forSaleProperty on ForSalePropertyV5 {\n  id\n  nodeId\n  ...PropertyLocationForCard_propertyV5\n  ...ForSalePropertyAttributes_property\n  ...PropertyMlsLabel_propertyV5\n  ...PropertyPageForSalePropertyListingDetails_property\n  ...ForSalePropertyStatus_forSalePropertyV5\n  description\n  ...PropertyPrice_property\n  agentV2 {\n    __typename\n    ... on VisibleForSalePropertyAgent {\n      agent {\n        id\n        nodeId\n      }\n    }\n  }\n  ...ForSalePropertyLabels_property\n  client {\n    id\n    nodeId\n  }\n  images(first: 1) {\n    edges {\n      node {\n        url(width: 324, height: 324, crop: false, embed: true)\n        nodeId\n      }\n    }\n  }\n  matchingType\n}\n\nfragment ConversationPageSelectedConversationContext_rentalNeed on RentalNeedV5 {\n  id\n  headline\n  remarks\n  client {\n    id\n    nodeId\n  }\n  agent {\n    id\n    nodeId\n  }\n  priceRange {\n    maxPrice {\n      formatted(format: SHORT)\n    }\n    minPrice {\n      formatted(format: SHORT)\n    }\n  }\n  areas {\n    edges {\n      node {\n        name\n        label\n        nodeId\n      }\n    }\n  }\n  propertyTypes {\n    displayName\n  }\n  minBeds\n  ...RentalNeedLeaseAttributes_rentalNeedV5\n  ...RentalNeedStatus_rentalNeedV5\n}\n\nfragment ConversationPageSelectedConversationContext_rentalProperty on RentalPropertyV5 {\n  id\n  ...RentalPropertyStatus_rentalPropertyV5\n  ...PropertyLocationForCard_propertyV5\n  ...RentalPropertyAttributes_property\n  ...PropertyMlsLabel_propertyV5\n  ...PropertyPageRentalPropertyListingDetails_property\n  ...RentalPropertyLease_rentalProperty\n  description\n  ...PropertyPrice_property\n  agent {\n    id\n    nodeId\n  }\n  client {\n    id\n    nodeId\n  }\n  images(first: 1) {\n    edges {\n      node {\n        ...PropertyCardImage_image\n        nodeId\n      }\n    }\n  }\n}\n\nfragment ConversationPageSelectedConversationDisplayer_conversation on ConversationV5 {\n  id\n  ...ConversationPageSelectedConversationAnonymousControl_conversation\n  conversationContext {\n    __typename\n    ...ConversationPageSelectedConversationContext_conversation\n    ...ConversationPageSelectedConversationMatches_conversation\n  }\n  ...ConversationPageSelectedConversationHeader_conversation\n  visibility\n  ...ConversationPageConversation_conversation\n}\n\nfragment ConversationPageSelectedConversationHeader_conversation on ConversationV5 {\n  conversationParticipants: participants(first: 20) {\n    ...ConversationParticipantsDisplay_participantsConnection\n  }\n}\n\nfragment ConversationPageSelectedConversationMatchesBuyerMatches_match on MatchForBuyerNeedV5 {\n  id\n  source {\n    client {\n      id\n      displayName\n      nodeId\n    }\n    priceRange {\n      maxPrice {\n        formatted(format: FULL)\n      }\n      minPrice {\n        formatted(format: FULL)\n      }\n    }\n    nodeId\n  }\n}\n\nfragment ConversationPageSelectedConversationMatchesRentalOwnerMatches_match on MatchForRentalPropertyV5 {\n  source {\n    price {\n      __typename\n      ... on ExactPrice {\n        price {\n          formatted(format: FULL)\n        }\n      }\n    }\n    propertyLocation {\n      __typename\n      ... on PropertyLocationWithHiddenAddress {\n        locationDisplay\n      }\n      ... on PropertyLocationWithVisibleAddress {\n        locationDisplay\n      }\n    }\n    client {\n      id\n      displayName\n      nodeId\n    }\n    nodeId\n  }\n}\n\nfragment ConversationPageSelectedConversationMatchesRenterMatches_match on MatchForRentalNeedV5 {\n  id\n  source {\n    client {\n      id\n      displayName\n      nodeId\n    }\n    priceRange {\n      maxPrice {\n        formatted(format: FULL)\n      }\n      minPrice {\n        formatted(format: FULL)\n      }\n    }\n    nodeId\n  }\n}\n\nfragment ConversationPageSelectedConversationMatchesSellerMatches_match on MatchForForSalePropertyV5 {\n  id\n  source {\n    price {\n      __typename\n      ... on ExactPrice {\n        price {\n          formatted(format: FULL)\n        }\n      }\n    }\n    propertyLocation {\n      __typename\n      ... on PropertyLocationWithHiddenAddress {\n        locationDisplay\n      }\n      ... on PropertyLocationWithVisibleAddress {\n        locationDisplay\n        address\n      }\n    }\n    client {\n      id\n      displayName\n      contacts {\n        edges {\n          node {\n            displayName\n            nodeId\n          }\n        }\n      }\n      nodeId\n    }\n    nodeId\n  }\n}\n\nfragment ConversationPageSelectedConversationMatches_conversation on ContextForConversation {\n  __isContextForConversation: __typename\n  __typename\n  ... on RemovedConversationContext {\n    agent {\n      id\n      nodeId\n    }\n  }\n  ... on AvailableConversationContext {\n    context {\n      __typename\n      ... on ForSalePropertyV5 {\n        currentUsersMatches(includeOnlyActive: true) {\n          totalCount\n          edges {\n            node {\n              ...ConversationPageSelectedConversationMatchesBuyerMatches_match\n              nodeId\n            }\n          }\n        }\n        agentV2 {\n          __typename\n          ... on VisibleForSalePropertyAgent {\n            agent {\n              id\n              nodeId\n            }\n          }\n        }\n      }\n      ... on RentalPropertyV5 {\n        currentUsersMatches(includeOnlyActive: true) {\n          totalCount\n          edges {\n            node {\n              ...ConversationPageSelectedConversationMatchesRenterMatches_match\n              nodeId\n            }\n          }\n        }\n        agent {\n          id\n          nodeId\n        }\n      }\n      ... on BuyerNeedV5 {\n        currentUsersMatches(includeOnlyActive: true) {\n          totalCount\n          edges {\n            node {\n              ...ConversationPageSelectedConversationMatchesSellerMatches_match\n              nodeId\n            }\n          }\n        }\n        agent {\n          id\n          nodeId\n        }\n      }\n      ... on RentalNeedV5 {\n        currentUsersMatches(includeOnlyActive: true) {\n          totalCount\n          edges {\n            node {\n              ...ConversationPageSelectedConversationMatchesRentalOwnerMatches_match\n              nodeId\n            }\n          }\n        }\n        agent {\n          id\n          nodeId\n        }\n      }\n      ... on DevelopmentProject {\n        agent {\n          id\n          nodeId\n        }\n      }\n      ... on DevelopmentProjectSampleUnit {\n        agent {\n          id\n          nodeId\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        __typename\n        nodeId\n      }\n    }\n  }\n}\n\nfragment ConversationParticipantsDisplay_participantsConnection on ConversationParticipantConnection {\n  edges {\n    node {\n      __typename\n      ... on Agent {\n        id\n        displayName\n        ...AgentProfilePhoto_agent\n        membershipStatus\n      }\n      ... on AnonymousConversationParticipant {\n        __typename\n      }\n      ... on Node {\n        __isNode: __typename\n        __typename\n        nodeId\n      }\n    }\n  }\n}\n\nfragment ConversationsPageRelayCommonGetClientNames_client on ClientV5 {\n  __isClientV5: __typename\n  __typename\n  id\n  contacts {\n    edges {\n      node {\n        displayName\n        nodeId\n      }\n    }\n  }\n}\n\nfragment ConversationsPageRelayCommon_conversationContext on ConversationContextV5 {\n  __isConversationContextV5: __typename\n  __typename\n  ... on BuyerNeedV5 {\n    id\n  }\n  ... on ForSalePropertyV5 {\n    id\n  }\n  ... on MessageBroadcast {\n    id\n  }\n  ... on RentalNeedV5 {\n    id\n  }\n  ... on RentalPropertyV5 {\n    id\n  }\n  ... on DevelopmentProject {\n    id\n  }\n  ... on DevelopmentProjectSampleUnit {\n    id\n  }\n}\n\nfragment DevelopmentUnitSearchResultAttributes_newDevelopmentSampleUnit on DevelopmentProjectSampleUnit {\n  beds {\n    __typename\n    ... on DevelopmentProjectUnitExactBeds {\n      beds\n    }\n    ... on DevelopmentProjectUnitBedsRange {\n      minBeds\n      maxBeds\n    }\n  }\n  baths {\n    __typename\n    ... on DevelopmentProjectUnitExactBaths {\n      baths\n    }\n    ... on DevelopmentProjectUnitBathsRange {\n      minBaths\n      maxBaths\n    }\n  }\n  squareFeet {\n    __typename\n    ... on DevelopmentProjectUnitExactSquareFeet {\n      squareFeet\n    }\n    ... on DevelopmentProjectUnitSquareFeetRange {\n      minSquareFeet\n      maxSquareFeet\n    }\n  }\n}\n\nfragment ForSalePropertyAttributes_property on ForSalePropertyV5 {\n  propertyType {\n    __typename\n    ... on CondoProperty {\n      ...CondoPropertyAttributes_condoProperty\n    }\n    ... on SingleFamilyProperty {\n      ...SingleFamilyPropertyAttributes_singleFamilyProperty\n    }\n    ... on LotProperty {\n      ...LotPropertyAttributes_lotProperty\n    }\n    ... on MultiUnitProperty {\n      ...MultiUnitPropertyAttributes_multiUnitProperty\n    }\n  }\n}\n\nfragment ForSalePropertyLabels_property on ForSalePropertyV5 {\n  id\n  forSaleMatchingType: matchingType\n  agentV2 {\n    __typename\n    ... on AnonymousForSalePropertyAgent {\n      __typename\n    }\n  }\n}\n\nfragment ForSalePropertyStatus_forSalePropertyV5 on ForSalePropertyV5 {\n  ...AgentPropertyMlsStatus_property\n  status {\n    __typename\n    ... on ActiveProperty {\n      __typename\n    }\n    ... on ExpiredProperty {\n      __typename\n    }\n    ... on SoldProperty {\n      __typename\n    }\n    ... on UnderContractProperty {\n      __typename\n    }\n    ... on WithdrawnProperty {\n      __typename\n    }\n  }\n}\n\nfragment LotPropertyAttributes_lotProperty on LotProperty {\n  lotSizeV2 {\n    value\n    unit\n  }\n  displayName\n}\n\nfragment MultiUnitPropertyAttributes_multiUnitProperty on MultiUnitProperty {\n  numberOfUnits\n  displayName\n}\n\nfragment PropertyCardImage_image on ImageAttachment {\n  url(width: 324, height: 324, crop: false, embed: true)\n}\n\nfragment PropertyLocationForCard_propertyV5 on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  ...UseShouldShowPropertyDetails_propertyV5\n  propertyLocation {\n    __typename\n    ... on PropertyLocationWithHiddenAddress {\n      locationDisplay\n    }\n    ... on PropertyLocationWithVisibleAddress {\n      locationDisplay\n      address\n      visibilityRule\n    }\n  }\n}\n\nfragment PropertyMlsLabel_propertyV5 on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  mlsPlan {\n    __typename\n    ... on ListOnMlsAsActive {\n      onMlsAt\n    }\n    ... on ListOnMlsAsComingSoon {\n      activeOnMlsOn\n    }\n    ... on NoMlsPlan {\n      __typename\n    }\n  }\n  activeOnMlsSince\n}\n\nfragment PropertyPageForSalePropertyListingDetails_property on ForSalePropertyV5 {\n  commission\n  propertyType {\n    __typename\n    ... on CondoProperty {\n      parkingSpaces\n      parkingDetails\n    }\n  }\n  onTanAt\n  updatedAt\n  showings {\n    edges {\n      node {\n        startDate\n        nodeId\n      }\n    }\n  }\n  mlsPlan {\n    __typename\n    ... on ListOnMlsAsActive {\n      onMlsAt\n      willAcceptOffersPriorToMls\n      willShowPriorToMls\n    }\n    ... on ListOnMlsAsComingSoon {\n      activeOnMlsOn\n      willAcceptOffersPriorToMls\n      willShowPriorToMls\n    }\n  }\n  website\n  chapter {\n    timezone\n    nodeId\n  }\n}\n\nfragment PropertyPageRentalPropertyListingDetails_property on RentalPropertyV5 {\n  propertyType {\n    __typename\n    ... on CondoProperty {\n      parkingSpaces\n      parkingDetails\n    }\n  }\n  onTanAt\n  updatedAt\n  mlsPlan {\n    __typename\n    ... on ListOnMlsAsActive {\n      onMlsAt\n    }\n    ... on ListOnMlsAsComingSoon {\n      activeOnMlsOn\n    }\n  }\n  website\n  chapter {\n    timezone\n    nodeId\n  }\n}\n\nfragment PropertyPrice_price_4wzfKn on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  price {\n    __typename\n    ...PropertyPrice_propertyPrice_4wzfKn\n  }\n}\n\nfragment PropertyPrice_property on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  ... on ForSalePropertyV5 {\n    ...PropertyPrice_price_4wzfKn\n  }\n  ... on RentalPropertyV5 {\n    ...PropertyPrice_price_4wzfKn\n  }\n}\n\nfragment PropertyPrice_propertyPrice_4wzfKn on PropertyPrice {\n  __isPropertyPrice: __typename\n  __typename\n  ... on PriceRange {\n    minPrice {\n      formatted(format: FULL)\n    }\n    maxPrice {\n      formatted(format: FULL)\n    }\n  }\n  ... on ExactPrice {\n    price {\n      formatted(format: FULL)\n    }\n  }\n}\n\nfragment RentalNeedLeaseAttributes_rentalNeedV5 on RentalNeedV5 {\n  availableFrom\n  leaseLength {\n    displayName\n  }\n}\n\nfragment RentalNeedStatus_rentalNeedV5 on RentalNeedV5 {\n  status {\n    __typename\n    ... on ActiveRentalNeed {\n      __typename\n    }\n    ... on ExpiredRentalNeed {\n      __typename\n    }\n    ... on RentedRentalNeed {\n      __typename\n    }\n    ... on WithdrawnRentalNeed {\n      __typename\n    }\n    ... on RemovedRentalNeed {\n      __typename\n    }\n  }\n}\n\nfragment RentalPropertyAttributes_property on RentalPropertyV5 {\n  propertyType {\n    __typename\n    ... on CondoProperty {\n      ...CondoPropertyAttributes_condoProperty\n    }\n    ... on SingleFamilyProperty {\n      ...SingleFamilyPropertyAttributes_singleFamilyProperty\n    }\n  }\n}\n\nfragment RentalPropertyLease_rentalProperty on RentalPropertyV5 {\n  availableFrom\n  leaseLength {\n    displayName\n  }\n}\n\nfragment RentalPropertyStatus_rentalPropertyV5 on RentalPropertyV5 {\n  ...AgentPropertyMlsStatus_property\n  status {\n    __typename\n    ... on ActiveProperty {\n      __typename\n    }\n    ... on ExpiredProperty {\n      __typename\n    }\n    ... on RentedProperty {\n      __typename\n    }\n    ... on WithdrawnProperty {\n      __typename\n    }\n  }\n}\n\nfragment SingleFamilyPropertyAttributes_singleFamilyProperty on SingleFamilyProperty {\n  beds\n  baths\n  halfBaths\n  lotSizeV2 {\n    value\n    unit\n  }\n  livingArea\n  displayName\n}\n\nfragment UseShouldShowPropertyDetails_propertyV5 on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  ... on ForSalePropertyV5 {\n    agentV2Id: agentV2 {\n      __typename\n      ... on VisibleForSalePropertyAgent {\n        agent {\n          id\n          nodeId\n        }\n      }\n      ... on AnonymousForSalePropertyAgent {\n        __typename\n      }\n    }\n  }\n  ... on RentalPropertyV5 {\n    agentId: agent {\n      id\n      nodeId\n    }\n  }\n}\n",
    "providedVariables": providedVariablesDefinition
  }
};
})());
}

let node = makeNode(providedVariablesDefinition);

function load(environment, variables, fetchPolicy, fetchKey, networkCacheConfig) {
  return ReactRelay.loadQuery(environment, node, convertVariables(variables), {
    fetchKey: fetchKey,
    fetchPolicy: fetchPolicy,
    networkCacheConfig: networkCacheConfig
  });
}

function queryRefToObservable(token) {
  return Primitive_option.fromNullable(token.source);
}

function queryRefToPromise(token) {
  return new Promise((resolve, _reject) => {
    let o = queryRefToObservable(token);
    if (o !== undefined) {
      Primitive_option.valFromOption(o).subscribe({
        complete: () => resolve({
          TAG: "Ok",
          _0: undefined
        })
      });
      return;
    } else {
      return resolve({
        TAG: "Error",
        _0: undefined
      });
    }
  });
}

let wrap_response_conversationById = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_conversationById = unwrap_response_conversationById;
exports.wrap_response_conversationById = wrap_response_conversationById;
exports.Internal = Internal;
exports.Utils = Utils;
exports.providedVariablesDefinition = providedVariablesDefinition;
exports.node = node;
exports.load = load;
exports.queryRefToObservable = queryRefToObservable;
exports.queryRefToPromise = queryRefToPromise;
/* node Not a pure module */
